import styles from './TextGradient.module.css'
import {CSSProperties} from "react";
export const TextGradient = ({colors, text, fontSize,fontWeigth}:{colors:string[], text:string, fontSize:string,fontWeigth:string})=>{

    function  getCssProp(){
        var strColors = "";
        colors.map(value => {strColors=strColors+ value + ","})
        const colorProps:CSSProperties={
            display:"inline-flex",
            fontSize:fontSize,
            fontWeight:fontWeigth,
            backgroundImage:"linear-gradient(to right,"+ colors.join(",")+")",
            WebkitBackgroundClip:"text",
            WebkitTextFillColor:"transparent",
            textAlign:"center"
        }
        return colorProps;
    }

    return(
        <div style={{display:"flex", justifyContent:"center"}}>
            <span style={getCssProp()} >
                {text}
            </span>
        </div>
    )
}